import React, { Component } from 'react';
import { connect } from 'react-redux';
import HeatMapBlock from '../Charts/HeatMapBlock';
import DownloadButton from '../../Component/UI/DownloadButton';
import Heading from '../../Component/UI/Heading';
import { LuDownload } from "react-icons/lu";
// import { MdOutlineClose } from "react-icons/md";
// import html2canvas from 'html2canvas';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
    this.state = {
      showMainPage: true,
      showFilter: false,
      showValue: '',
      showTabView: 2,
      showModalDownload: false,
      themeTab: "Top 5"
    }
  }

  componentDidMount() {

  }

  changeTab = (value) => {
    this.setState({ themeTab: value })
  }

  render() {
    let { list } = this.props;
    let { themeTab } = this.state;

    return (
      <>
        <div className="w-full">
          <div className='flex items-center justify-between pb-5'>
            <Heading className="text-xl" title="Dominant TalentPlusStrengths Theme" />
          </div>

          <div className="md:p-6 p-4 bg-white border border-[#D1D5DB] shadow-sm rounded-xl">
            <div className="flex justify-between pb-5">
              <div className="w-full flex justify-start">
                <div className="flex bg-white border border-[#D1D5DB] rounded-2xl p-1 space-x-3 shadow-sm">

                  {["Top 5", "Top 7", "Top 10"].map((name) =>
                    <button
                      onClick={() => this.changeTab(name)}
                      className={
                        (themeTab === name) ? "px-6 py-2 rounded-xl bg-blue-50 textcolor font-semibold" :
                          "px-6 py-2 rounded-xl text font-medium hover:bg-blue-100 hover:text-[#1976D2] transition"
                      }>{name}</button>
                  )}

                </div>
              </div>
              <div>
                <DownloadButton label="Download" Icon={LuDownload} onClick={this.handleDownload} />
              </div>
            </div>

            <div className={'grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4'}>
              {list && list.length > 0 ?
                list.map((item) =>
                  <>
                    <div className={''}>
                      <h1 className='text-lg text-center textblack font-semibold bg-[#F2F2F2] px-4 py-3 mb-2'>
                        {item.bucket}
                      </h1>
                      <HeatMapBlock item={item} isSchool={false} themeTab={themeTab} />
                    </div>
                  </>
                ) : null}
            </div>
          </div>
        </div >
      </>
    );
  }
}
function mapStateToProps(state) {
  // ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { users, dashboard } = state;
  return {
    loggingIn,
    users,
    dashboard
  };
}
export default connect(mapStateToProps)(Overview);
